import {
  ArrowRightOutlined,
  CalendarTwoTone,
  CloseOutlined,
  EditOutlined,
  PercentageOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import Sheet from 'react-modal-sheet';
import {
  Button,
  Card,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  InputNumberProps,
  Modal,
  Progress,
  Slider,
  SliderSingleProps,
  Typography,
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { DashboardContext } from '..';
import bank from '../../../Assets/bank.svg';
import goal_others from '../../../Assets/goal_default.svg';
import goal_car from '../../../Assets/goals_car.svg';
import goal_emergency from '../../../Assets/goals_emergency.svg';
import goal_home from '../../../Assets/goals_home.svg';
import goal_retirement from '../../../Assets/goals_retirement.svg';
import goal_startup from '../../../Assets/goals_startup.svg';
import mutualFunds from '../../../Assets/mutualFunds.svg';
import insurance from '../../../Assets/insurance.svg';
import nps from '../../../Assets/nps.svg';
import deposits from '../../../Assets/deposits.svg';

import stocks from '../../../Assets/stocks.svg';
import { logoBaseURL } from '../../../Utils/constants';
import getNudges from '../../../Utils/nudgeUtils';
import {
  categoriesMapping,
  categoryLogos,
  convertAmoutToINRWithNotation,
  formatToINR,
  getAccounts,
  getClosingBalance,
  getKeyByValue,
  getTopCredit,
  getTopDebit,
  getTotalCreditAmount,
  getTotalDebitAmount,
  getTotalNetworthObject,
} from '../../../Utils/utils';
import BudgetHomeScreen from '../BudgetScreen';
import HorizontalMenu from '../Goals/menu';
import Insights from '../Insights';
import InsightsPage from '../Insights/InsightsPage';
import LiabilitiesView from '../Liabilities';
import Nudges from '../Nudges';
import NudgesPage from '../Nudges/NudgesPage';
import GarageHomeTile from '../Garage/HomeTile';
import styles from './index.module.css';
import { initiateJourney } from '../../../Services/PFMClient/ConsentService';
import { setAccessToken, setUserId } from '../../../Utils/storageUtils';
import { AppContext } from '../../../App';

type props = {
  defaultView?: string;
};
const dataNetworth = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 5800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 5708,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 8800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 5800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 9000,
    amt: 2100,
  },
];

const Home: React.FC<props> = ({ defaultView = 'assets' }) => {
  const {
    navigateToSpends,
    navigateToPortfolio,
    navigateToGoalDetails,
    navigateToCalendarView,
    navigateToGarage,
    goals,
    setGoals,
  }: any = useContext(DashboardContext);
  const { navigateToAA, setCurrentSelectedCard }: any = useContext(AppContext);
  const [currentView, setCurrentView] = useState(defaultView);
  const [modalVisible, setModalVisible] = useState(false);
  const [showGoalName, setShowGoalName] = useState(false);
  const [isLinkingNewAssets, setIsLinkingNewAssts] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    goalName: '',
    yearsAway: 1,
    amount: 0,
    percent: 0,
  });
  const [selectedGoal, setSelectedGoal] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showInsightsPage, setShowInsightsPage] = useState(false);
  const [showNudgesPage, setShowNudgesPage] = useState(false);

  const onChange: InputNumberProps['onChange'] = (newValue) => {
    setFormData({ ...formData, yearsAway: newValue as number });
  };

  const marks: SliderSingleProps['marks'] = {
    1: '1Y',
    25: '25Y',
  };
  useEffect(() => {
    if (defaultView) {
      setCurrentView(defaultView);
    }
  }, [defaultView]);

  const renderCurrentView = () => {
    switch (currentView) {
      case 'assets':
        return (
          <>
            <Card>
              <div
                className={styles.fi_div_item}
                onClick={() => {
                  navigateToSpends('1');
                }}
              >
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={bank}
                  />
                  Banks
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  ₹{convertAmoutToINRWithNotation(getClosingBalance())}
                </Typography.Text>
              </div>
              <Divider style={{ margin: '12px 0px' }} />

              <div
                className={styles.fi_div_item}
                onClick={() => {
                  if (getTotalNetworthObject().totalMutualFundsValue !== 0)
                    navigateToPortfolio('MUTUAL_FUNDS');
                }}
              >
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={mutualFunds}
                  />
                  Mutual Funds
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  {getTotalNetworthObject().totalMutualFundsValue === 0 ? (
                    <Button
                      type='text'
                      style={{
                        color: '#ED1F47',
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        fontWeight: 600,
                        paddingRight: 0,
                      }}
                      icon={<ArrowRightOutlined />}
                    >
                      Connect
                    </Button>
                  ) : (
                    <>
                      ₹
                      {convertAmoutToINRWithNotation(
                        getTotalNetworthObject().totalMutualFundsValue
                      )}
                    </>
                  )}
                </Typography.Text>
              </div>

              <Divider style={{ margin: '12px 0px' }} />

              <div
                className={styles.fi_div_item}
                onClick={() => {
                  if (getTotalNetworthObject().totalEquitiesalue !== 0)
                    navigateToPortfolio('STOCKS');
                }}
              >
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={stocks}
                  />
                  Stocks
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  {getTotalNetworthObject().totalEquitiesalue === 0 ? (
                    <Button
                      type='text'
                      style={{
                        color: '#ED1F47',
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        fontWeight: 600,
                        paddingRight: 0,
                      }}
                      icon={<ArrowRightOutlined />}
                    >
                      Connect
                    </Button>
                  ) : (
                    <>
                      ₹
                      {convertAmoutToINRWithNotation(
                        getTotalNetworthObject().totalEquitiesalue
                      )}
                    </>
                  )}
                </Typography.Text>
              </div>
              <Divider style={{ margin: '12px 0px' }} />
              <div
                className={styles.fi_div_item}
                onClick={() => {
                  navigateToPortfolio('DEPOSITS');
                }}
              >
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={deposits}
                  />
                  Fixed & Recurring Deposits
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  ₹{convertAmoutToINRWithNotation(928114)}
                </Typography.Text>
              </div>
              <Divider style={{ margin: '12px 0px' }} />
              <div className={styles.fi_div_item}>
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={nps}
                  />
                  NPS
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  <>₹{convertAmoutToINRWithNotation(229833)}</>
                </Typography.Text>
              </div>
              <Divider style={{ margin: '12px 0px' }} />
              <div className={styles.fi_div_item}>
                <Typography.Text className={styles.fi_name}>
                  <PercentageOutlined
                    className={styles.icon}
                    style={{ padding: 14 }}
                  />
                  GST
                </Typography.Text>
                <Button
                  type='text'
                  style={{
                    color: '#ED1F47',
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    fontWeight: 600,
                    paddingRight: 0,
                  }}
                  icon={<ArrowRightOutlined />}
                >
                  Connect
                </Button>
              </div>
              <Divider style={{ margin: '12px 0px' }} />
              <div className={styles.fi_div_item}>
                <Typography.Text className={styles.fi_name}>
                  <Image
                    preview={false}
                    style={{ width: 20 }}
                    rootClassName={styles.icon}
                    src={insurance}
                  />
                  Insurances
                </Typography.Text>
                <Typography.Text className={styles.connect_button}>
                  Coming Soon
                </Typography.Text>
              </div>
              {/* <Divider style={{ margin: '12px 0px' }} /> */}

              {/* <div
              className={styles.fi_div_item}
              onClick={() => {
                navigateToLiabilitiesView();
              }}
            >
              <Typography.Text className={styles.fi_name}>
                <Image
                  style={{ width: 20 }}
                  preview={false}
                  rootClassName={styles.icon}
                  src={liability}
                />
                Liabilities
              </Typography.Text>
              <Typography.Text className={styles.connect_button}>
                ₹
                {convertAmoutToINRWithNotation(
                  getTotalNetworthObject().totalEquitiesalue
                )}
              </Typography.Text>
            </div> */}

              {/* <Divider style={{ marginTop: '0' }} />

      <div className={styles.fi_div_item}>
        <Typography.Text className={styles.fi_name}>
          Deposits
        </Typography.Text>
        <Typography.Text className={styles.connect_button}>
          <PlusCircleTwoTone />
        </Typography.Text>
      </div> */}
              <div
                style={{
                  display: 'flex',
                  marginTop: '15px',
                  justifyContent: 'center',
                }}
              >
                <Button
                  className={styles.primaryButton}
                  onClick={() => {
                    setPhoneNumber('');
                    setIsLinkingNewAssts(true);
                  }}
                >
                  <PlusOutlined />
                  Link more assets
                </Button>
              </div>
            </Card>
            <GarageHomeTile onClick={() => navigateToGarage && navigateToGarage()} />
            <Nudges nudgeList={getNudges()} onViewAll={() => setShowNudgesPage(true)} />
            <Insights onViewAll={() => setShowInsightsPage(true)} />
          </>
        );
      case 'goals':
        return (
          <>
            <Card>
              <div className={styles.goalContainer}>
                {Object.keys(goals).map((g, index: number) => {
                  const localGoal = goals[g];
                  return (
                    <Card className={styles.goalCard}>
                      <div
                        className={styles.fi_div_item}
                        style={{
                          display: 'block',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div>
                            <Typography.Text
                              className={styles.fi_name}
                              onClick={() => {
                                navigateToGoalDetails('Emergency');
                              }}
                            >
                              <Image
                                preview={false}
                                style={{ width: 20 }}
                                rootClassName={styles.icon}
                                src={
                                  g.toLowerCase().includes('emergency')
                                    ? goal_emergency
                                    : g.toLowerCase().includes('car')
                                    ? goal_car
                                    : g.toLowerCase().includes('home')
                                    ? goal_home
                                    : g.toLowerCase().includes('Retire')
                                    ? goal_retirement
                                    : g.toLowerCase().includes('startup')
                                    ? goal_startup
                                    : goal_others
                                }
                              />
                              {g}
                            </Typography.Text>
                          </div>
                          <div>
                            <Button
                              icon={<EditOutlined />}
                              shape='circle'
                              onClick={() => {
                                showModal(g);
                                setFormData({
                                  amount: localGoal.amount,
                                  goalName: localGoal.goalName,
                                  yearsAway: localGoal.yearsAway,
                                  percent: localGoal.percent,
                                });
                              }}
                              style={{ border: 'none', width: '10%' }}
                            />
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div>
                              <Typography.Text
                                className={styles.why_aa_text}
                                style={{ color: 'grey' }}
                              >
                                {localGoal.yearsAway
                                  ? '' + localGoal.yearsAway + ' year/s away'
                                  : ''}
                              </Typography.Text>
                            </div>
                            <div>
                              <Typography.Text
                                className={styles.why_aa_text}
                                style={{ color: 'grey' }}
                              >
                                {localGoal.amount
                                  ? formatToINR(localGoal.amount.toString())
                                  : formatToINR('0')}
                              </Typography.Text>
                            </div>
                          </div>
                          <div>
                            <Progress
                              percent={localGoal.percent}
                              size={['100%', 7]}
                              status='active'
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>

              {/* <div
              className={styles.fi_div_item}
              style={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
              <div>
                <Typography.Text
                  className={styles.fi_name}
                  onClick={() => {
                    navigateToGoalDetails('Home');
                  }}
                >
                  Home
                </Typography.Text>

                <Typography.Text
                  className={styles.why_aa_text}
                  style={{ color: 'grey' }}
                >
                  {data.get('Home')?.yearsAway
                    ? '' + data.get('Home').yearsAway + ' year/s away'
                    : ''}
                </Typography.Text>
              </div>

              <div>
                <Typography.Text
                  className={styles.why_aa_text}
                  style={{ color: 'grey' }}
                >
                  {data.get('Home')?.amount
                    ? 'Rs. ' + data.get('Home').amount
                    : ''}
                </Typography.Text>
              </div>

              <Typography.Text
                className={styles.connect_button}
                onClick={() => showModal('Home')}
              >
                Plan
              </Typography.Text>
            </div>

            <Divider style={{ margin: '12px 0px' }} />

            <div
              className={styles.fi_div_item}
              style={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
              <div>
                <Typography.Text
                  className={styles.fi_name}
                  onClick={() => {
                    navigateToGoalDetails('Travel');
                  }}
                >
                  Travel
                </Typography.Text>

                <Typography.Text
                  className={styles.why_aa_text}
                  style={{ color: 'grey' }}
                >
                  {data.get('Travel')?.yearsAway
                    ? '' + data.get('Travel').yearsAway + ' year/s away'
                    : ''}
                </Typography.Text>
              </div>

              <div>
                <Typography.Text
                  className={styles.why_aa_text}
                  style={{ color: 'grey' }}
                >
                  {data.get('Travel')?.amount
                    ? 'Rs. ' + data.get('Travel').amount
                    : ''}
                </Typography.Text>
              </div>

              <Typography.Text
                className={styles.connect_button}
                onClick={() => showModal('Travel')}
              >
                Plan
              </Typography.Text>
            </div> */}

              <Button
                onClick={() => {
                  showModal('new');
                }}
                className={styles.primaryButton}
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: 16,
                  display: 'flex',
                }}
              >
                Add Goal
              </Button>

              <Modal
                title={showGoalName ? 'Add a New Goal' : selectedGoal}
                visible={modalVisible}
                centered
                onCancel={closeModal}
                onOk={handleFormSubmit}
                okButtonProps={{
                  style: {
                    background: '#ED1F47',
                    color: 'white',
                    borderRadius: 20,
                  },
                }}
                cancelButtonProps={{
                  style: {
                    borderColor: '#ED1F47',
                    color: '#ED1F47',
                    borderRadius: 20,
                  },
                }}
              >
                <Form layout='vertical'>
                  {showGoalName ? (
                    <Form.Item label='Goal Name'>
                      <Input
                        maxLength={20}
                        name='goalName'
                        value={formData.goalName}
                        onChange={handleFormChange}
                      />
                    </Form.Item>
                  ) : (
                    ''
                  )}

                  <Form.Item label='Amount (INR)'>
                    <InputNumber
                      style={{ width: '100%' }}
                      max={20000000}
                      name='amount'
                      value={formData.amount}
                      onChange={handleFormChangeAmount}
                    />
                  </Form.Item>
                </Form>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Typography.Text>
                    Planned for {new Date().getFullYear() + formData.yearsAway}
                  </Typography.Text>
                  <InputNumber
                    suffix={'Yrs'}
                    min={1}
                    max={25}
                    style={{ margin: '0px' }}
                    value={formData.yearsAway}
                    onChange={onChange}
                  />
                </div>
                <Slider
                  className='sliderGoals'
                  tooltip={{ visible: false }}
                  min={1}
                  max={25}
                  onChange={onChange}
                  marks={marks}
                  value={
                    typeof formData.yearsAway === 'number'
                      ? formData.yearsAway
                      : 0
                  }
                />
              </Modal>
            </Card>
            <Nudges nudgeList={getNudges('goal')} />
          </>
        );
      case 'budget':
        return <BudgetHomeScreen />;
      case 'liabilities':
        return <LiabilitiesView onBack={() => {}} />;
    }
  };

  const showModal = (goalName: string) => {
    setModalVisible(true);
    if (goalName === 'new') {
      setShowGoalName(true);
    } else {
      setShowGoalName(false);
    }
    setSelectedGoal(goalName);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedGoal('');
    setFormData({ goalName: '', yearsAway: 1, amount: 0, percent: 0 });
  };

  const handleFormChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormChangeAmount = (e: any) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      amount: e,
    }));
  };

  const handleFormSubmit = () => {
    let localGoal = selectedGoal;
    if (selectedGoal === 'new') {
      localGoal = formData.goalName;
    }

    setGoals({ ...goals, [localGoal]: formData });
    closeModal();
  };

  const renderTopTransactions = (transaction: any) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography.Text
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
          }}
        >
          <img
            height={16}
            src={
              logoBaseURL +
              categoryLogos[
                getKeyByValue(categoriesMapping, transaction.category)!
              ] +
              '.jpg'
            }
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src =
                logoBaseURL + 'f7080c52-607c-46b3-8263-112cefcd5dae.jpg';
            }}
          />
          {transaction.category}
        </Typography.Text>

        <Typography.Text className={styles.connect_button}>
          ₹{convertAmoutToINRWithNotation(transaction.amount)}
        </Typography.Text>
      </div>
    );
  };

  if (showInsightsPage) {
    return <InsightsPage onBack={() => setShowInsightsPage(false)} />;
  }

  if (showNudgesPage) {
    return <NudgesPage nudgeList={getNudges()} onBack={() => setShowNudgesPage(false)} />;
  }

  return (
    <>
      <Sheet
        style={{
          zIndex: 100,
          maxWidth: 450,
          margin: 'auto',
        }}
        isOpen={isLinkingNewAssets}
        onClose={() => {
          setIsLinkingNewAssts(false);
        }}
        detent='content-height'
        disableScrollLocking={true}
      >
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content>
            <div className={styles.linkAssetsSheet}>
              <Typography.Text style={{ fontSize: 24, fontWeight: 600 }}>
                Enter mobile number to link your assets
              </Typography.Text>
              <br />
              <br />
              <Typography.Text style={{ color: 'gray' }}>
                Assets linked with this mobile number can be tracked
              </Typography.Text>

              <div style={{ display: 'flex' }}>
                <Input
                  id='mobileNumberInput'
                  placeholder='Enter your mobile number'
                  maxLength={10}
                  value={phoneNumber}
                  onInput={(e: any) => {
                    setPhoneNumber(e.target.value.replace(/[^0-9.]/g, ''));
                  }}
                  type='tel'
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  className={styles.primaryButton}
                  loading={isLoading}
                  style={{
                    marginTop: 15,
                    display: 'flex',
                    width: '60%',
                  }}
                  disabled={phoneNumber.length !== 10}
                  onClick={async () => {
                    setIsLoading(true);

                    try {
                      setUserId(phoneNumber);
                      const refreshToken = await initiateJourney();
                      if (refreshToken?.data === 'ERROR') {
                        // setIsError(true);
                        return;
                      }
                      setAccessToken(refreshToken?.data.redirectionUrl);
                      setUserId(refreshToken?.data.userId);
                      navigateToAA();
                      setCurrentSelectedCard(1);
                    } catch (e) {
                      console.log('232', e);
                      return;
                    }
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop
          onTap={() => {
            setIsLinkingNewAssts(false);
          }}
        />
      </Sheet>
      <div className={styles.dashboard_main_div}>
        <div className={styles.dashboard_div}>
          <Card style={{ background: 'rgb(0, 46, 220)' }}>
            <div className={styles.netWorthCard}>
              <Typography.Text
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#fff',
                }}
              >
                My Networth
              </Typography.Text>

              <Typography.Text
                style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#fff',
                }}
              >
                {`${formatToINR(
                  getTotalNetworthObject().totalNetworth.toString()
                )}
          `}
              </Typography.Text>

              <ResponsiveContainer width={'100%'} height={100}>
                <AreaChart
                  data={dataNetworth}
                  margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                >
                  <defs>
                    <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
                      <stop offset='5%' stopColor='#8884d8' stopOpacity={0.8} />
                      <stop offset='95%' stopColor='#8884d8' stopOpacity={0} />
                    </linearGradient>
                    <linearGradient id='colorPv' x1='0' y1='0' x2='0' y2='1'>
                      <stop offset='5%' stopColor='#82ca9d' stopOpacity={0.8} />
                      <stop offset='95%' stopColor='#82ca9d' stopOpacity={0} />
                    </linearGradient>
                  </defs>

                  <Area
                    type='monotone'
                    dataKey='pv'
                    stroke='#82ca9d'
                    fillOpacity={1}
                    fill='url(#colorPv)'
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Card>

          <HorizontalMenu
            currentView={currentView}
            setCurrentView={setCurrentView}
          />

          {renderCurrentView()}
        </div>
        <div className={styles.rightColumnContainer}>
          <Card
            style={{ width: '100%' }}
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: 'fit-content',
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                >
                  Spends Insights
                </Typography.Text>
                <Typography.Text
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                ></Typography.Text>
                <CalendarTwoTone
                  style={{ fontSize: 24, color: 'blue' }}
                  onClick={() => {
                    navigateToCalendarView();
                  }}
                />
              </div>
            }
          >
            <div
              style={{ display: 'flex' }}
              onClick={() => navigateToSpends('2')}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexDirection: 'column',

                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                      }}
                    >
                      <Typography.Text
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        Inflow
                      </Typography.Text>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M19.0711 4.92895C19.4616 5.31947 19.4616 5.95264 19.0711 6.34316L8.05026 17.364H14.1213C14.6736 17.364 15.1213 17.8117 15.1213 18.364C15.1213 18.9163 14.6736 19.364 14.1213 19.364H5.63605C5.08376 19.364 4.63605 18.9163 4.63605 18.364V9.87869C4.63605 9.32641 5.08376 8.87869 5.63605 8.87869C6.18833 8.87869 6.63605 9.32641 6.63605 9.87869V15.9498L17.6569 4.92895C18.0474 4.53842 18.6806 4.53842 19.0711 4.92895Z'
                          fill='green'
                        />
                      </svg>
                    </div>

                    <Typography.Text
                      style={{
                        fontSize: '20px',
                      }}
                    >
                      ₹ {getTotalCreditAmount().toLocaleString('en-IN')}
                    </Typography.Text>

                    <Typography.Text
                      style={{
                        fontSize: '10px',
                      }}
                    >
                      {`${getAccounts()} bank accounts` ?? ''}
                    </Typography.Text>
                  </div>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L12.5858 12L10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289Z'
                      fill='#0460ff'
                    />
                  </svg>
                </div>
                <Divider type='vertical' />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px',
                      }}
                    >
                      <Typography.Text
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        Outflow
                      </Typography.Text>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M8.87867 5.63604C8.87867 5.08375 9.32639 4.63604 9.87867 4.63604H18.364C18.9162 4.63604 19.364 5.08375 19.364 5.63604V14.1213C19.364 14.6736 18.9162 15.1213 18.364 15.1213C17.8117 15.1213 17.364 14.6736 17.364 14.1213V8.05025L6.34314 19.0711C5.95261 19.4616 5.31945 19.4616 4.92893 19.0711C4.5384 18.6805 4.5384 18.0474 4.92893 17.6569L15.9497 6.63604H9.87867C9.32639 6.63604 8.87867 6.18832 8.87867 5.63604Z'
                          fill='red'
                        />
                      </svg>
                    </div>
                    <Typography.Text
                      style={{
                        fontSize: '20px',
                      }}
                    >
                      ₹ {getTotalDebitAmount().toLocaleString('en-IN')}
                    </Typography.Text>
                    <Typography.Text
                      style={{
                        fontSize: '10px',
                      }}
                    >
                      {`${getAccounts()} bank accounts` ?? ''}
                    </Typography.Text>
                  </div>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L12.5858 12L10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289Z'
                      fill='#0460ff'
                    />
                  </svg>
                </div>
              </div>
            </div>
          </Card>
          <Card
            style={{ width: '100%' }}
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: 'fit-content',
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                  }}
                >
                  Top credit
                </Typography.Text>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M19.0711 4.92895C19.4616 5.31947 19.4616 5.95264 19.0711 6.34316L8.05026 17.364H14.1213C14.6736 17.364 15.1213 17.8117 15.1213 18.364C15.1213 18.9163 14.6736 19.364 14.1213 19.364H5.63605C5.08376 19.364 4.63605 18.9163 4.63605 18.364V9.87869C4.63605 9.32641 5.08376 8.87869 5.63605 8.87869C6.18833 8.87869 6.63605 9.32641 6.63605 9.87869V15.9498L17.6569 4.92895C18.0474 4.53842 18.6806 4.53842 19.0711 4.92895Z'
                    fill='green'
                  />
                </svg>
              </div>
            }
          >
            <div>
              {getTopCredit().map((transaction: any) =>
                renderTopTransactions(transaction)
              )}
            </div>
          </Card>
          <Card
            style={{ width: '100%' }}
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: 'fit-content',
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                  }}
                >
                  Top debit
                </Typography.Text>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M8.87867 5.63604C8.87867 5.08375 9.32639 4.63604 9.87867 4.63604H18.364C18.9162 4.63604 19.364 5.08375 19.364 5.63604V14.1213C19.364 14.6736 18.9162 15.1213 18.364 15.1213C17.8117 15.1213 17.364 14.6736 17.364 14.1213V8.05025L6.34314 19.0711C5.95261 19.4616 5.31945 19.4616 4.92893 19.0711C4.5384 18.6805 4.5384 18.0474 4.92893 17.6569L15.9497 6.63604H9.87867C9.32639 6.63604 8.87867 6.18832 8.87867 5.63604Z'
                    fill='red'
                  />
                </svg>
              </div>
            }
          >
            <div>
              {getTopDebit().map((transaction: any) =>
                renderTopTransactions(transaction)
              )}
            </div>
          </Card>
        </div>
      </div>
      <div className={styles.why_aa_div}>
        <Typography.Text className={styles.why_aa_text}>
          {' '}
          This project is for demonstration purposes only. All data is mocked
          and does not represent real information.
        </Typography.Text>
        {/* <Typography.Text
            className={styles.why_aa_link}
            onClick={() => {
              setIsWhyAAModalOpen(true);
            }}
          >
            Why Account Aggregator is Safe?
          </Typography.Text> */}
      </div>
    </>
  );
};

export default Home;
